import React from 'react';
import { Section, SectionSubTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import { FLOOR_SCREED_ADVANTAGES_LIST } from './floor-screed-advantages-section-constants';
import {
  title,
  advantagesList,
  advantageIcon,
  advantageName,
} from './floor-screed-advantages-section-styles';

export const FloorScreedAdvantagesSection = () => (
  <Section>
    <SectionSubTitle className={title} margin="l">
      Преимущества технологии полусухой стяжки
    </SectionSubTitle>
    <ul className={advantagesList}>
      {FLOOR_SCREED_ADVANTAGES_LIST.map((advantage, index) => (
        <li key={createElementKey('floor-screed-advantage', index)}>
          <img
            className={advantageIcon}
            src={advantage.imageSrc}
            alt={advantage.imageAlt}
            title={advantage.imageAlt}
            width="40"
            height="40"
            loading="lazy"
          />
          <Typography className={advantageName} variant="h3">
            {advantage.name}
          </Typography>
          <Typography variant="m" size="body_long">
            {advantage.text}
          </Typography>
        </li>
      ))}
    </ul>
  </Section>
);
